webpackJsonp([19843951674672],{

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(31);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectList = function ProjectList(_ref) {
		var title = _ref.title,
		    subtitle = _ref.subtitle,
		    featuredImage = _ref.featuredImage,
		    link = _ref.link,
		    html = _ref.html;
		return _react2.default.createElement(
			'div',
			{ className: 'project-list' },
			_react2.default.createElement(
				'div',
				{ className: 'project-list__image' },
				_react2.default.createElement(
					'a',
					{ href: link, target: '_blank', rel: 'noopener noreferrer' },
					_react2.default.createElement(_gatsbyImage2.default, { sizes: featuredImage, alt: title })
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'project-list__content' },
				_react2.default.createElement(
					'div',
					{ className: 'project-list__titles' },
					_react2.default.createElement(
						'h2',
						{ className: 'title is-4' },
						title
					),
					_react2.default.createElement(
						'h3',
						{ className: 'subtitle is-6' },
						subtitle
					)
				),
				typeof html === 'string' ? _react2.default.createElement('div', {
					className: 'content project-list__text has-text-justified',
					dangerouslySetInnerHTML: { __html: html }
				}) : _react2.default.createElement(
					'div',
					{ className: 'content project-list__text has-text-justified' },
					html
				),
				_react2.default.createElement(
					'div',
					{ className: 'project-list__link' },
					_react2.default.createElement(
						'a',
						{
							href: link,
							target: '_blank',
							rel: 'noopener noreferrer',
							className: 'button is-medium is-outlined is-rounded'
						},
						'VISIT'
					)
				)
			)
		);
	};
	
	ProjectList.propTypes = {
		title: _propTypes2.default.string.isRequired,
		subtitle: _propTypes2.default.string.isRequired,
		featuredImage: _propTypes2.default.shape({
			sizes: _propTypes2.default.string.isRequired,
			srcSet: _propTypes2.default.string.isRequired
		}).isRequired,
		link: _propTypes2.default.string.isRequired,
		html: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = ProjectList;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.projectQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Page = __webpack_require__(27);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ProjectList = __webpack_require__(70);
	
	var _ProjectList2 = _interopRequireDefault(_ProjectList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects(props) {
		var _props$data = props.data,
		    edges = _props$data.projects.edges,
		    shortTitle = _props$data.site.siteMetadata.shortTitle,
		    pageBG = _props$data.pageBG;
	
		return _react2.default.createElement(
			_Page2.default,
			{
				title: 'Projects \u2013 ' + shortTitle,
				subtitle: 'Total ' + edges.length + ' projects published',
				hero: pageBG.childImageSharp
			},
			edges.map(function (project) {
				var _project$node = project.node,
				    html = _project$node.html,
				    id = _project$node.id,
				    _project$node$frontma = _project$node.frontmatter,
				    featuredImage = _project$node$frontma.featured_image.childImageSharp.sizes,
				    title = _project$node$frontma.title,
				    subtitle = _project$node$frontma.subtitle,
				    link = _project$node$frontma.link;
	
				return _react2.default.createElement(_ProjectList2.default, _extends({
					key: id
				}, {
					title: title,
					html: html,
					link: link,
					featuredImage: featuredImage,
					subtitle: subtitle
				}));
			})
		);
	};
	
	Projects.propTypes = {
		data: _propTypes2.default.shape({
			projects: _propTypes2.default.object,
			site: _propTypes2.default.object,
			pageBG: _propTypes2.default.object
		}).isRequired
	};
	
	exports.default = Projects;
	var projectQuery = exports.projectQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-jsx-844be6e4a279e97ca0cb.js